import type { GetAllowedValues } from './QuantitySelector.d';

export function decrement(value: number, min: number) {
  const canDecrement = value > min;

  return canDecrement ? value - 1 : min;
}

export function getAllowedValue({ max, min, value }: GetAllowedValues) {
  const numeralValue = parseValue(value);
  const shouldNotDecrement = numeralValue < min;
  const shouldNotIncrement = numeralValue > max;

  if (shouldNotDecrement) {
    return min;
  }

  if (shouldNotIncrement) {
    return max;
  }

  return numeralValue;
}

export function increment(value: number, max: number) {
  const canIncrement = value < max;

  return canIncrement ? value + 1 : value;
}

export function parseValue(value: string) {
  const parsedValue = parseInt(value, 10) || 0;

  return parsedValue;
}
